<template>
  <div class="footer-meta togo-meta">
    <div class="locations-wrap">
      <template v-for="(location,i) of locations">
        <TogoMenuLocation
          v-if="location.acf"
          :class="[{right:i+1 == locations.length},{center:locations.length == 3 && i+1 == 2}]"
          :location="location"
          :key="location.id"
        />
      </template>
    </div>
    <div class="hours-and-website-wrap" :style="`font-size:${fontSize}`">
      <div class="hours">Open 7 Days, 7am - 5pm</div>
      <div class="website">SatsumaCafe.com</div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";

import TogoMenuLocation from './TogoMenuLocation'

export default {
  name: "DrinksFooterMeta",
  components : { TogoMenuLocation },
  created() {
    this.getLocations();
  },
  data() {
    return {
      locations: []
    };
  }, // data
  computed: {
    ...mapState(["wpData","fontSize"]),
  }, // computed
  methods: {
    async getLocations() {
      const response = await axios(
        `${this.wpData.rest_url}/wp/v2/${this.wpData.cpts.locations}`
      );
      this.locations = response.data;
    } // getLocations
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Menus/DrinksFooterMeta.vue